import React from 'react'

const CookiePolicy = () => {
  return (
    <div>
      CookiePolicy
    </div>
  )
}

export default CookiePolicy